export const WORLD_CUP_STANDINGS_MODAL_TEST_ID = 'world-cup-standings-modal';

export const STANDINGS_VIEWS = {
  GROUPS: 'groups',
  KNOCKOUT: 'knockout',
} as const;

export type StandingsModalView = (typeof STANDINGS_VIEWS)[keyof typeof STANDINGS_VIEWS];

import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

export const getStandingsEmptySubtitle = (): string =>
  `Group tables will appear here after the ${getWcBrand().NAME} standings are synced.`;

export const STANDINGS_MODAL_COPY = {
  TITLE: 'STANDINGS',
  SECTION_GROUP_STANDINGS: 'GROUP STANDINGS',
  GROUPS_TAB: 'Groups',
  KNOCKOUT_TAB: 'Knockout',
  KNOCKOUT_PLACEHOLDER:
    'Knockout bracket will show here after the group stage. We will wire this to API-Football.',
  FOOTNOTE:
    'Tables show the official group-stage order from the live feed.',
  GUEST_FOOTNOTE:
    'Preview standings use sample data until you sign in.',
  LOADING: 'Loading official standings...',
  EMPTY_TITLE: 'Standings not available yet',
  ERROR_TITLE: 'Could not load standings',
  ERROR_SUBTITLE: 'Try again in a moment.',
  ACCESSIBILITY_OPEN: 'Open tournament standings',
  ACCESSIBILITY_OPEN_GROUPS: 'Open group standings',
  ACCESSIBILITY_CLOSE: 'Close standings',
  GROUP_HEADING_PREFIX: 'GROUP',
  THIRD_PLACE_HEADING: '3RD-PLACED TEAMS',
  LEGEND_QUALIFIED: 'Qualified',
  LEGEND_POSSIBLE_3RD: 'Possible 3rd',
  LEGEND_THIRD_PLACE_QUALIFIED: 'Top 8 qualify',
} as const;

export const STANDINGS_TABLE_COLS = {
  TEAM: 'Team',
  P: 'P',
  W: 'W',
  D: 'D',
  L: 'L',
  GD: 'GD',
  PTS: 'Pts',
} as const;

/** Top 2 qualify automatically; 3rd may advance as best third-place. */
export const QUALIFYING_POSITION_LIMIT = 2;
export const POSSIBLE_3RD_POSITION = 3;
/** In the cross-group third-placed-teams ranking, the best 8 advance (2026 format). */
export const THIRD_PLACE_QUALIFY_LIMIT = 8;
